import { useEffect, useMemo } from "react";
import { useItems } from "../../hooks/use-items.ts";
import { useOwnedWarbonds } from "../../hooks/use-owned-warbonds.ts";

const INIT_KEY = "hd2:ownedInitialized:v2";
const STARTER_SOURCE_NAME = "Starter Equipment";

export function OwnedDefaultsInitializer() {
	const items = useItems();
	const { setMany } = useOwnedWarbonds();

	const allSourceNames = useMemo(() => {
		if (items.loading) {
			return [];
		}
		const set = new Set<string>();
		for (const w of items.weapons) {
			set.add(w.warbondSource || STARTER_SOURCE_NAME);
		}
		for (const s of items.stratagems) {
			set.add(s.warbondSource || STARTER_SOURCE_NAME);
		}
		for (const b of items.boosters) {
			set.add(b.warbondSource || STARTER_SOURCE_NAME);
		}
		for (const p of items.passives) {
			for (const a of p.armors) {
				set.add(a.warbondSource || STARTER_SOURCE_NAME);
			}
		}
		return [...set];
	}, [items]);

	useEffect(() => {
		if (allSourceNames.length === 0) {
			return;
		}
		function seedIfNeeded() {
			if (localStorage.getItem(INIT_KEY) === "1") {
				return;
			}
			setMany(allSourceNames, true);
			localStorage.setItem(INIT_KEY, "1");
		}
		seedIfNeeded();
		window.addEventListener("hd2:ownedWarbondsChange", seedIfNeeded);
		return () => {
			window.removeEventListener("hd2:ownedWarbondsChange", seedIfNeeded);
		};
	}, [allSourceNames, setMany]);

	return null;
}
